import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const ActivityFeed = ({ activities }) => {
  const activityIcons = {
    shipment: 'Ship',
    cost: 'DollarSign',
    issue: 'AlertTriangle',
    document: 'FileText',
    user: 'User',
    system: 'Settings'
  };

  const activityColors = {
    shipment: 'text-primary',
    cost: 'text-success',
    issue: 'text-error',
    document: 'text-accent',
    user: 'text-secondary',
    system: 'text-muted-foreground'
  };

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="flex items-center justify-between p-4 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Activity" size={20} className="text-primary" />
          <h3 className="font-semibold text-foreground">Recent Activity</h3>
        </div>
      </div>
      <div className="divide-y divide-border max-h-96 overflow-y-auto custom-scrollbar">
        {activities?.map((activity) => (
          <div key={activity?.id} className="p-4 hover:bg-muted/50 transition-colors">
            <div className="flex items-start gap-3">
              {activity?.userAvatar ? (
                <Image
                  src={activity?.userAvatar}
                  alt={activity?.userAvatarAlt}
                  className="w-10 h-10 rounded-full object-cover"
                />
              ) : (
                <div className={`w-10 h-10 rounded-full flex items-center justify-center bg-muted ${activityColors?.[activity?.type]}`}>
                  <Icon name={activityIcons?.[activity?.type]} size={20} />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground mb-1">
                  <span className="font-medium">{activity?.user}</span>
                  {' '}
                  <span className="text-muted-foreground">{activity?.action}</span>
                </p>
                {activity?.details && (
                  <p className="text-xs text-muted-foreground mb-2">{activity?.details}</p>
                )}
                <div className="flex items-center gap-3 text-xs text-muted-foreground">
                  <span className="flex items-center gap-1">
                    <Icon name="Clock" size={12} />
                    {activity?.time}
                  </span>
                  {activity?.reference && (
                    <span className="flex items-center gap-1">
                      <Icon name="Hash" size={12} />
                      {activity?.reference}
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityFeed;